import { API, authClient } from "../index";

export const postOfferPartida = async (offerPartida, accessToken) => {
  return authClient(accessToken).post(`${API}/offer-partidas`, offerPartida);
};

export const postOfferPartidaNewRevision = async (
  id,
  offerPartida,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/offer-partidas/${id}`,
    offerPartida
  );
};

export const postOfferPartidaRevision = async (
  id,
  offerPartida,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/offer-partidas/${id}/revision`,
    offerPartida
  );
};
export const getOfferPartidas = (accessToken) => {
  return authClient(accessToken).get(`${API}/offer-partidas`);
};

export const getOfferPartidasById = (id, accessToken) => {
  return authClient(accessToken).get(`${API}/offer-partidas/${id}/all`);
};

export const getOfferChapterByIdAndRevision = (
  id,
  revisionNumber,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/offer-partidas/${id}?revision=${revisionNumber}`
  );
};

export const updateOfferPartida = async (id, offerPartida, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-partidas/${id}`,
    offerPartida
  );
};

export const reorderOfferPartida = async (id, payload, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-partidas/${id}/position`,
    payload
  );
};

export const deleteOfferPartida = (partidaId, accessToken) => {
  return authClient(accessToken).delete(`${API}/offer-partidas/${partidaId}`);
};

export const importOfferPartidaDecomposition = (id, payload, accessToken) => {
  return authClient(accessToken).post(
    `${API}/offer-partidas/${id}/import-decomposition`,
    payload
  );
};
